import './BannerSlide.css';

function BannerSlide({ image, imageAlt }) {
  return (
    <div className="banner-slide">
      <img className="banner-slide__image" src={image} alt={imageAlt || ''} />
    </div>
  );
}

export default BannerSlide;
